<div class="lum-modal">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">{{
      appIntegrationAccountHeadingTitle
    }}</span>
  </div>
  <div class="lum-modal__body">
    <div
      class="overlay"
      lumAppLoader
      [loading]="loading"
      [classes]="'loading blur'"
    ></div>
    <ng-container *ngIf="inventoryLocations.length > 0; else empty">
      <table class="lum-table lum-table--classic striped">
        <thead class="table__head-row">
          <th class="w-p25">Location ID</th>
          <th class="w-p25">Name</th>
          <th class="w-p25">Address</th>
          <th class="">Default</th>
          <th class=""></th>
        </thead>
        <tbody>
          <ng-container
            *ngFor="let location of inventoryLocations; trackBy: trackById"
          >
            <tr>
              <td>{{ location.locationId }}</td>
              <td>{{ location.name }}</td>
              <td>{{ location.metadata?.address1 }}</td>
              <td class="text-center">
                <ng-container *ngIf="location.default">
                  <i class="fas fa-check text-success"></i>
                </ng-container>
              </td>
              <td>
                <div class="table-action--wrapper flex justify-content-end">
                  <a mat-button [matMenuTriggerFor]="bulkMenu">
                    <i class="fas fa-ellipsis-h"></i>
                  </a>
                  <mat-menu #bulkMenu="matMenu">
                    <button mat-menu-item (click)="onSetForAllProducts(location)">
                      Use for all Products
                    </button>
                    <button mat-menu-item (click)="onSetDefaultLocation(location)">
                      Assign Location as Default
                    </button>
                  </mat-menu>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>

      <mat-paginator
        [length]="pagination.total || 0"
        [pageSize]="pagination.per_page || paginationConfig.perPage"
        [pageSizeOptions]="paginationConfig.pageSizeOptions"
        [pageIndex]="(pagination.current_page || 1) - 1"
        (page)="onPaginationEvent($event)"
        aria-label="Select page"
      >
      </mat-paginator>
    </ng-container>

    <ng-template #empty>
      <lum-ui-empty-page
        *ngIf="!loading"
        title="There are no Inventory Locations to show"
      ></lum-ui-empty-page>
    </ng-template>
  </div>
  <div class="lum-modal__footer">
    <div class="flex ml-auto lum-modal__action">
      <button
        type="button"
        class="lum-button lum-button--secondary mr-2"
        mat-button
        (click)="onClose()"
      >
        Close
      </button>
      <button
        mat-button
        type="button"
        class="lum-button"
        [disabled]="btnGetLocationsLoading"
        (click)="onGetLocations()"
      >
        Get Locations
      </button>
    </div>
  </div>
</div>
